/* eslint-disable import/no-cycle */
import { ElMessage, ElMessageBox, ElNotification } from 'element-plus';
import router, { resetRouter } from '@/router';
import {
  getAuthOrLicenseResponseCode,
  getLicenseErrorCode,
  getLocalizedAuthOrLicenseResponseMessage,
  isLicenseApiRequest,
} from '@/js/licenseMessage';

let redirecting = false;
const recentMessages = {};
const MESSAGE_DEDUP_MS = 3000;

const removeStaleOverlays = () => {
  document
    .querySelectorAll('.el-overlay, .el-message-box__wrapper')
    .forEach((element) => element.remove());
  document.body.classList.remove('el-popup-parent--hidden');
  document.body.style.removeProperty('overflow');
  document.body.style.removeProperty('padding-right');
};

export const shouldForceLogin = (error) => {
  if (isLicenseApiRequest(error)) return false;

  const status = error.response?.status;
  const message = error.response?.data?.msg;

  return status === 401 || message === 'AUTH_CODE_407' || !!getLicenseErrorCode(message);
};

/**
 * 顯示強制登入訊息
 * @param {*} error
 * @returns
 */
const showForceLoginMessage = (error) => {
  const errorCode = getAuthOrLicenseResponseCode(error);
  const errorMsg = getLocalizedAuthOrLicenseResponseMessage(error);
  if (!errorCode || !errorMsg) return false;

  const now = Date.now();
  if (recentMessages[errorCode] && now - recentMessages[errorCode] < MESSAGE_DEDUP_MS) {
    return true;
  }

  recentMessages[errorCode] = now;
  ElMessage({
    showClose: true,
    message: errorMsg,
    type: 'error',
    duration: 5000,
  });
  return true;
};

/**
 * 強制登入
 * @param {*} param0
 * @returns
 */
export const forceLogin = ({ closeMessages = true, error } = {}) => {
  if (redirecting) return;
  redirecting = true;

  if (closeMessages) ElMessage.closeAll();
  const messageShown = showForceLoginMessage(error);
  ElMessageBox.close();
  ElNotification.closeAll();
  removeStaleOverlays();

  localStorage.clear();
  sessionStorage.clear();
  resetRouter();

  router.replace('/login').finally(() => {
    window.dispatchEvent(new Event('force-login'));
    // Teleported dialogs can finish their leave transition after navigation.
    window.setTimeout(removeStaleOverlays, 0);
    window.setTimeout(removeStaleOverlays, 300);
    window.setTimeout(() => {
      if (!messageShown) {
        Object.keys(recentMessages).forEach((key) => {
          if (Date.now() - recentMessages[key] >= MESSAGE_DEDUP_MS) delete recentMessages[key];
        });
      }
      redirecting = false;
    }, 500);
  });
};
